import { Component, OnInit } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';

@Component({
  selector: 'app-add-participant-popup',
  templateUrl: './add-participant-popup.component.html',
  styleUrls: ['./add-participant-popup.component.css']
})
export class AddParticipantPopupComponent implements OnInit {

  constructor() { }

  myControl = new UntypedFormControl();
  options: string[] = ['Parker', 'Harry', 'Roger','marley','peter'];

  ngOnInit(): void {
  }

}
